module.exports = __webpack_public_path__ + "static/media/01.e9ec7313.jpg";